import type { DateTime, Duration } from 'luxon'
import type { ReactElement } from 'react'

import type { AlertVariant } from '@/components/UI/Alert'

export type UseBannerStateProps = {
  startDateTime: DateTime
  endDateTime: DateTime
  zoomEndDateTime: DateTime | null
  attemptedHosting: boolean
}

export enum BannerStateType {
  UpcomingDistant = 'upcoming-distant',
  UpcomingSoonZoomClosed = 'upcoming-soon-zoom-closed',
  UpcomingSoonZoomOpen = 'upcoming-soon-zoom-open',
  Live = 'live',
  LiveNoShowWarning = 'live-no-show-warning',
  LiveSessionEndedEarly = 'live-session-ended-early',
  NoShow = 'no-show',
  None = 'none',
}

export interface BannerState {
  type: BannerStateType
  startFromNow: Duration
  now: DateTime
}

export type BannerOptionsNextToTitleTag = {
  bgColor: string
  textColor: string
  icon: ReactElement | null
  text: string
  width: string | null
} | null

export type BannerOptionsColors = {
  accentColor: string
  borderIconColor: string
  primaryTextColor: string
  secondaryTextColor: string
  shadowColor: string
  shapeColor: string
  backgroundColor: string
}

export type BannerOptionsButton = {
  disabled: boolean
  tooltip: string | null
} | null

export type BannerOptions = {
  colors: BannerOptionsColors
  aboveAlert: ReactElement | string | null
  alert: {
    variant: AlertVariant
    message: ReactElement | string
  } | null
  beneathAlert: ReactElement | string | null
  showVideoIcon: boolean
  nextToTitleTag: BannerOptionsNextToTitleTag
  showTimespanUnderneathTitle: boolean
  button: BannerOptionsButton
  showCornerCountdownTag: boolean
}
